import script from "./AddAttachmentsLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddAttachmentsLayout.vue?vue&type=script&setup=true&lang=ts"

import "./AddAttachmentsLayout.vue?vue&type=style&index=0&id=4504c31a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4504c31a"]])

export default __exports__